/**
 * CreateDate: 5/5/15
 * Author: EliorC
 * Descriptions:
 *  a mediator class to mediate the chat and messaging for the agent.
 *
 * Change Log:
 *  11/5/15     - version 0.2.0     - dynamic resolver.
 *  5/5/15      - version 0.1.0     - Facade Layering.
 */


/**
 *  Concept:
 *
 *  the router will hold inside the mapping for the methods.
 *  each method mapping will hold configuration that indicate the resolve strategy and the endpoints.
 *
 *  -------------         Logic Controller      | [V] -> Real-Time -> endPoint Execution.
 *  -           -       ===================     | [X] -> Messaging
 *  -   Method  -  -- >  Resolve Strategy | =>  | [X] -> ...
 *  -           -       ===================     | [X] -> ...
 *  -------------                               | [X] -> ...
 *
 *  the resolve strategy can return one or more endpoint's of execution for example, a login method should be invoked
 *  async in both Real-Time and Messaging will flag the two containers for execution.
 *  Ex:
 *
 *  -------------         Logic Controller      | [V] -> Real-Time -> endPoint Execution.
 *  -           -       ===================     | [V] -> Messaging -> endPoint Execution.
 *  -   login   -  -- >  Resolve All      | =>  | [V] -> ...       -> endPoint Execution.
 *  -           -       ===================     | [V] -> ...       -> endPoint Execution.
 *  -------------                               | [V] -> ...       -> endPoint Execution.
 *
 * Router Configuration:
 *
 * direct routing:
 * --------------
 * the direct routing will point to a single endpoint and will not use the resolver.
 *
 * example:
 * {
 *    transferChat:     'RealTime.Chat'
 * }
 *
 * dynamic routing:
 * ---------------
 * the dynamic routing will ask for a resolver, if not supplied the default resolver will be taken from the
 * routerConfig object.
 *
 * the endpoints should point to the path in the container.
 *
 * example:
 * {
 *      addLine: {
 *           resolveStrategy: 'ResolveByChatId', -- optional - if not supplied will be taken from the config.
 *           endPoints: {
 *               // the endpoint's should match the logicController.engagementTypes enum.
 *               realTimeChat: 'RealTime.Chat'
 *           }
 *       }
 * }
 * */

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.lpTag.WebAgent.logicController = window.lpTag.WebAgent.logicController || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var lpAppMediator = function (model) {

        var applicationType = 'lpAppMediator';
        var logger = WebAgentLogger.getLogger(applicationType);

        /* --------------------------------- [ Configuration ] --------------------------------- */
        //var resolver = lpTag.WebAgent.engagementResolver;
        var routerConfig = {
            defaultResolveStrategy: 'ResolveByChatId',

            resolveStrategies: {
                ResolveByChatId: {
                    method: window.lpTag.WebAgent.logicController.getEngagementTypeByChatId,
                    params: ['chatId']
                },
                ResolveByVisitorId: {
                    method: window.lpTag.WebAgent.logicController.getEngagementTypeByVisitorId,
                    params: ['visitorId']
                }
            }
        };

        var router = {
            // Chat:
            setAgentTyping: {
                endPoints: {
                    realTimeChat: 'RealTime.Chat',
                    asyncMessaging: "AsyncMessaging.Conversations"
                }
            },
            endChat:                            'RealTime.Chat',
            getAgentSurvey:                     'RealTime.Chat',
            setAgentSurvey:                     'RealTime.Chat',
            startSpectate:                      'RealTime.Chat',
            stopSpectate:                       'RealTime.Chat',
            openEngagement: {
                endPoints: {
                    realTimeChat: 'RealTime.Chat',
                    asyncMessaging: "AsyncMessaging.Conversations"
                }
            },
            addLine: {
                endPoints: {
                    realTimeChat: 'RealTime.Chat',
                    asyncMessaging: "AsyncMessaging.Messages"
                }
            },
            // Agent:
            logInAgent:                         'RealTime.Agent',
            initSession:                        'RealTime.Agent',
            logOutAgent:                        'RealTime.Agent',
            acceptChat:                         'RealTime.Agent',
            saveSessionData:                    'RealTime.Agent',
            removeSessionData:                  'RealTime.Agent',
            getSessionData:                     'RealTime.Agent',
            setAvailability:                    'RealTime.Agent',
            setMsgStatus:                       'AsyncMessaging.Messages',
            setChatState:                       'AsyncMessaging.Conversations',
            closeDialog:                        'AsyncMessaging.Conversations',
            closeConversation:                  'AsyncMessaging.Conversations',
            unassignConversation:               'AsyncMessaging.Conversations',
            addReaderParticipant:               'AsyncMessaging.Conversations',
            removeReaderParticipant:            'AsyncMessaging.Conversations',
            addManagerParticipant:              'AsyncMessaging.Conversations',
            removeManagerParticipant:           'AsyncMessaging.Conversations',
            updateReaderParticipant:            'AsyncMessaging.Conversations',
            updateManagerParticipant:           'AsyncMessaging.Conversations',
            setAgentNote:                       'AsyncMessaging.Conversations',
            setManualSla:                       'AsyncMessaging.Conversations',
            restoreManualSla:                   'AsyncMessaging.Conversations',
            getServerTime:                      'AsyncMessaging.AMSController',
            subscribe:                          'AsyncMessaging.Subscriptions',
            unsubscribe:                        'AsyncMessaging.Subscriptions',
            createConversation:                 'AsyncMessaging.Conversations',
            getConversation:                    'AsyncMessaging.Conversations',
            resumeConversation:                 'AsyncMessaging.Conversations',
            populateChatHistoryConversation:    {
                resolveStrategy: 'ResolveByVisitorId',
                endPoints: {
                    realTimeChat: 'RealTime.EngagementsHistoryVisitor',
                    asyncMessaging:'AsyncMessaging.History'
                }
            },
            getDownloadUrl:                   'AsyncMessaging.fileSharingController',
            onFileSelected:                   'AsyncMessaging.fileSharingController',
            sendFile:                         'AsyncMessaging.fileSharingController',
            retryUploadFile:                  'AsyncMessaging.fileSharingController',

            // Transfer:
            getAvailableAgents: 'RealTime.Agent',
            transferChat: {
                endPoints: {
                    realTimeChat: 'RealTime.Transfer',
                    asyncMessaging: 'AsyncMessaging.Conversations'
                }
            },
            transferChatToRemoteAccount: 'RealTime.Transfer',
            getAvailableSkills: 'RealTime.Transfer',
            getAvailableRemoteAccounts: 'RealTime.Transfer',
            updateTransferDataForChat: {
                endPoints: {
                    realTimeChat: 'RealTime.Transfer',
                    asyncMessaging: "AsyncMessaging.Conversations"
                }
            }
        };

        var container = {
            RealTime: {
                Agent: lpTag.WebAgent.agentController,
                Chat: lpTag.WebAgent.chatController,
                Participant: lpTag.WebAgent.participantController,
                EngagementsHistoryVisitor: lpTag.WebAgent.engagementsHistoryVisitorController,
                Transfer: lpTag.WebAgent.transferController
            }
        };

        if (lpTag.WebAgent.logicController.hasMessagingFeature()) {
            container.AsyncMessaging = {
                AMSController: lpTag.WebAgent.amsController,
                AMSAgentStatusController: lpTag.WebAgent.amsAgentStatusController,
                Conversations: lpTag.WebAgent.amsConversationController,
                Subscriptions: lpTag.WebAgent.amsSubscriptionsController,
                UserProfiles: lpTag.WebAgent.amsUserProfilesController,
                Messages: lpTag.WebAgent.amsMessagesController,
                History: lpTag.WebAgent.messagingEngagementHistoryByConsumer,
                fileSharingController: lpTag.WebAgent.amsFileSharingController
            };
        }
        /* ------------------------------- [ Custom Mediator Api ] ----------------------------- */


        var lpAppMediatorApi = createPublicApi(router);

        lpAppMediatorApi.getModelParam = function (paramName) {
            return model.get(paramName);
        };

        lpAppMediatorApi.bindModelParam = function (modelParam, func, scope, trigger) {
            model.bind(modelParam, func, scope, trigger);
        };

        lpAppMediatorApi.unbindModelParam = function (key, callback, context) {
            model.unbind(key, callback, context);
        };

        lpAppMediatorApi.getChatHistory = function (reqObj) {
            // Custom controller resolver
            var controller = null;
            if (reqObj && reqObj.visitorId) {
                if (lpTag.WebAgent.logicController.isVisitorRealTimeChat(reqObj.visitorId)) {
                    var hasLiveEngage2Feature = agentLEManager.hasLiveEngage2Feature();
                    controller = hasLiveEngage2Feature ? container.RealTime.EngagementsHistoryVisitor : container.RealTime.Participant;
                } else {
                    controller = container.AsyncMessaging.History;
                }
            }
            invoke(controller, 'getChatHistory', arguments);
        };

        /* ------------------------------- [ Privates ] ----------------------------- */

        /**
         * invoke a function, injecting the scope and the args.
         * @param obj - the object holding teh function, also act as the context.
         * @param fnName - the function to invoke
         * @param args - the arguments to pass to the function.
         */
        function invoke(obj, fnName, args) {
            //console.log('Calling the ' + fnName + ' from the mediator', arguments);
            obj[fnName].apply(obj, args);
        }

        /**
         * Initialize the Mediator Router - create the public methods api wrapped with the custom invoker
         * @param router
         */
        function createPublicApi(router) {
            var api = {};
            for (var item in router) {
                if (router.hasOwnProperty(item)) {
                    api[item] = dispatcher(item);
                }
            }
            return api;


            /**
             * return the object from the container - lookup by the path key.
             * NOTE: this lookup support up to 5 levels deep. - this function optimized for performance.
             * @param path - the path to the container object eg: 'RealTime.Chat'.
             * @param object - the object reference to the key.
             * @returns {*}
             */
            function getContainerObjectByPath(path, object) {
                if (!path) {
                    return object;
                }

                // this is the fastest way to get fragmented object by flatten key.
                var pathParts = path.split('.');
                switch (pathParts.length) {
                    case 1:
                        return object[pathParts[0]];
                    case 2:
                        return object[pathParts[0]][pathParts[1]];
                    case 3:
                        return object[pathParts[0]][pathParts[1]][pathParts[2]];
                    case 4:
                        return object[pathParts[0]][pathParts[1]][pathParts[2]][pathParts[3]];
                    case 5:
                        return object[pathParts[0]][pathParts[1]][pathParts[2]][pathParts[3]][pathParts[4]];
                    default:
                        // TODO: fallback to generic loop lookup.
                        logger.error('object lookup dose not support this level', 'getContainerObjectByPath');
                        logger.graph({name: 'levelTooDeepError'});
                        return null;
                }
            }

            /**
             * custom function wrapping the requested command with the mediator scope data
             * this function will resolve the dependencies for the command and invoke the target function
             * with the parameters passed.
             * @param route
             * @returns {Function}
             */
            function dispatcher(route) {
                return function () {
                    var path = null;             // the container path
                    var strategy = null;             // the strategy to follow on this command
                    var routeConfig = router[route];    // the configuration for this route


                    // short config - if it's the direct path, don't use the strategy.
                    if (typeof routeConfig === 'string') {
                        path = routeConfig;
                    } else {
                        strategy = resolveRouteStrategy(routeConfig);
                    }

                    if (!path) {
                        path = resolvePathFromStrategy(route, strategy, arguments);
                    }

                    var obj = getContainerObjectByPath(path, container);
                    invoke(obj, route, arguments);
                };
            }
        }

        /**
         * get the route resolve strategy plan.
         * @param routeConfig - the config object of the route
         * @returns {*}
         */
        function resolveRouteStrategy(routeConfig) {
            var resolveStrategy = routerConfig.defaultResolveStrategy;
            if (routeConfig.hasOwnProperty('resolveStrategy')) {
                resolveStrategy = routeConfig.resolveStrategy;
            }
            return routerConfig.resolveStrategies[resolveStrategy];
        }

        /**
         * resolving the path from the strategy plan.
         * @param route - the route.
         * @param strategy - the strategy
         * @param args - the passed in arguments
         * @returns {*}
         */
        function resolvePathFromStrategy(route, strategy, args) {
            /**
             * storing the data to inject into the resolver function.
             * @type {Array}
             */
            var injectionParams = [];

            /**
             * iterate over the strategy configuration, if it's has params needed,
             * it will extract it from the data passed to the mediator public api call.
             */
            for (var i = 0; i < strategy.params.length; i++) {
                var paramName = strategy.params[i];
                if (args[0].hasOwnProperty(paramName)) {
                    injectionParams.push(args[0][paramName]);
                }
            }

            if (injectionParams.length === strategy.params.length) {
                var endpoint = strategy.method.apply(null, injectionParams);

                if (endpoint !== lpTag.WebAgent.logicController.engagementTypes.unknown) {
                    return router[route].endPoints[endpoint];
                } else {
                    logger.error('cannot find a valid endpoint', 'resolvePathFromStrategy');
                    logger.graph({name: 'noValidEndpointError'});
                }

            } else {
                logger.error("cannot find the parameter's to attach the resolver", 'resolvePathFromStrategy');
                logger.graph({name: 'cannotResolvePathError'});
                return null;
            }
        }

        /* ----------------------------- [ Exporting ] ---------------------------- */
        return lpAppMediatorApi;
    };

    return lpAppMediator;

});
